import { Button, CircularProgress  } from '@mui/material';

import palette from '../../../../styles/palette';

interface SaveAndExitButtonProps {
  onClick?: () => void;
  loading?: boolean;
}

export const SaveAndExitButton = ({ onClick, loading }: SaveAndExitButtonProps) => (
  <Button
    onClick={onClick}
    sx={
      {
        minWidth: 'auto',
        paddingX: 2,
        color: palette.neutral.plum['500'],
        fontWeight: 700,
        '&:hover': {
          color: palette.neutral.plum['400'],
          backgroundColor: 'transparent',
        },
      }
    }
    variant='text'
  >
    {loading ? <CircularProgress size={20} /> : 'Save & Exit'}
  </Button>
);

export default SaveAndExitButton;
